import { Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { DateTime } from 'luxon';
import { Fragment } from 'react/jsx-runtime';
import { TimelineData } from '../timeline-data';
import { DATE_HEADER_HEIGHT } from '../utils';

export const TimelineHeader = ({
  timeline,
  dateHeaderScale,
  onMonthClick,
}: {
  timeline: TimelineData;
  dateHeaderScale: number;
  onMonthClick?: (date: DateTime) => void;
}) => {
  const { headerDates, headerMonths, timelineStart } = timeline;
  const isClickable = !!onMonthClick;
  return (
    <div>
      {headerMonths.map(({ month, year, offset, newPeriod, monthIndex }, index) => (
        <Fragment key={offset}>
          <div
            className="absolute top-2 z-1"
            style={{
              left: offset * dateHeaderScale,
            }}
          >
            {(year || month) && (
              <Typography
                component="div"
                variant="subtitle1"
                color={grey[800]}
                fontWeight={600}
                onClick={() => {
                  if (isClickable) {
                    const clickedDate = DateTime.fromObject({
                      year: year ?? timelineStart.year,
                      month: DateTime.fromFormat(month, 'LLL').month,
                    });
                    onMonthClick(clickedDate);
                  }
                }}
                sx={{
                  cursor: isClickable ? 'pointer' : 'default',
                  '&:hover': isClickable ? { textDecoration: 'underline' } : {},
                }}
              >
                {monthIndex === 1 && year && `${year} `}
                {month.toUpperCase()}
              </Typography>
            )}
          </div>
          {newPeriod && index > 0 && (
            <div
              className="border-l border-gray-200 absolute bottom-0 z-10"
              style={{
                top: 0,
                left: Math.floor(offset * dateHeaderScale - 16),
              }}
            />
          )}
          {/** Dashed line separating months in track view */}
          <div
            className="border-l border-gray-200 border-dashed absolute bottom-0 z-10"
            style={{
              top: DATE_HEADER_HEIGHT,
              left: offset * dateHeaderScale,
            }}
          />
        </Fragment>
      ))}
      {headerDates.map(({ date, offset }) => (
        <div
          key={offset}
          className="absolute top-7 -translate-x-1/2 z-1"
          style={{
            left: offset * dateHeaderScale,
          }}
        >
          <span className="text-sm text-gray-500">{date}</span>
        </div>
      ))}
    </div>
  );
};
